module.exports = __webpack_public_path__ + "static/media/PCWorkshopeDataMICROSERVICEUSANDOSTREAMINGPARABIGDATAKAFKANODEJSGOGCP.212fdbc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/microservice/PCWorkshopeDataMICROSERVICEUSANDOSTREAMINGPARABIGDATAKAFKANODEJSGOGCP.png
// module id = 250
// module chunks = 0